import { render, staticRenderFns } from "./cascader.vue?vue&type=template&id=203583a1&scoped=true"
import script from "./cascader.vue?vue&type=script&lang=js"
export * from "./cascader.vue?vue&type=script&lang=js"
import style0 from "./cascader.vue?vue&type=style&index=0&id=203583a1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203583a1",
  null
  
)

export default component.exports